module.exports = __webpack_public_path__ + "static/media/jp.07631708.svg";